import { getBuilds as getBuildsRequest } from '@services/build';
import { BuildsActionsType, GOT_BUILDS } from '@store/types/build';

export const getBuilds = (): any => {
  return (dispatch: (action: BuildsActionsType) => void): any => {
    getBuildsRequest()
      .then((builds) => dispatch({ type: GOT_BUILDS, payload: builds }))
      .catch(() => {});
  };
};
